import { IBrandViewV2Response } from "@faire/web-api/indigofair/data/IBrandViewV2Response";

import { useBrandView } from "./useBrandView";

export const useBrand = (): IBrandViewV2Response.ILeanBrand | undefined => {
  return useBrandView()?.brand;
};
